import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    selection: {
        selectedCategory: undefined,
        selectedProduct: undefined,
        selectedShipping: null,
    },
    address: null,
    branch: {},
    productLayout: "grid",
    filter: {},
};
const slice = createSlice({
    name: "selection",
    initialState,
    reducers: {
        setSelectedCategory: (state, action) => {
            state.selection.selectedCategory = action.payload;
        },
        setSelectedProduct: (state, action) => {
            state.selection.selectedProduct = action.payload;
        },
        setSelectedAddress: (state, action) => {
            state.address = action.payload;
        },
        setSelectedProductLayout: (state, action) => {
            state.productLayout = action.payload;
        },
        setSelectedBranch: (state, action) => {
            state.branch = action.payload;
        },
        setSelectedFilter: (state, action) => {
            state.filter = action.payload;
        },
        setSelectedShipping: (state, action) => {
            state.selection.selectedShipping = action.payload;
        },
    },
});
export const { setSelectedCategory, setSelectedProduct, setSelectedAddress, setSelectedProductLayout, setSelectedBranch, setSelectedFilter, setSelectedShipping, } = slice.actions;
export default slice.reducer;
